import infoBar from './infoBar';

export default infoBar;
